import React from 'react';

import { Icon, Text, useTheme } from '@desygner/ui-common-components';

import { StyledBackButton, StyledStepHeader } from './StepHeader.styles';

export type StepHeaderPropsT = {
  title: string;
  isBackButtonHidden?: boolean;
  onBack?: () => void;
};

export const StepHeader = ({ ...props }: StepHeaderPropsT) => {
  const theme = useTheme();

  return (
    <StyledStepHeader>
      {!props.isBackButtonHidden && (
        <StyledBackButton onClick={props.onBack}>
          <Icon name="chevron---left" size="Medium" color={theme.Color.Neutrals.Text} />
        </StyledBackButton>
      )}

      <Text size="DisplaySmall">{props.title}</Text>
    </StyledStepHeader>
  );
};
